import styled from 'styled-components';
import { ListAction } from 'modules/campaigns/editor/types';
import { useCampaignContext } from 'modules/campaigns/editor/context';
import { getIsEligibilityCampaign } from 'modules/campaigns/editor/components/utils';
import { colors, spacing, body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { TextButton } from 'ui/button';

import { useAudienceContext } from '../../../context';
import { NoResults } from './NoResults';
import { ListDetail } from './ListDetail';

export const AUDIENCE_LIST_SUMMARY_TEST_ID = 'audience-list-summary';
export const AUDIENCE_LIST_SUMMARY_HEADER_TEST_ID = 'audience-list-summary-header';
export const AUDIENCE_LIST_SUMMARY_BODY_TEST_ID = 'audience-list-summary-body';
export const AUDIENCE_LIST_SUMMARY_ACTION_LINK_TEST_ID = 'audience-list-summary-action-link';

const SummaryWrapper = styled.div`
  width: 400px;
  background-color: ${colors.grey5};
  border-left: ${spacing.single} solid ${colors.grey15};
`;

const SummaryHeader = styled.div`
  ${body2}
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${pxToRem(16)} ${pxToRem(24)};
  gap: 8px;
  font-weight: 500;
  color: ${colors.textPrimary};
  border-bottom: 1px solid ${colors.grey15};
`;

const SummaryBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${pxToRem(16)} ${pxToRem(24)};
`;

export const AudienceListSummary = () => {
  const {
    selectedSendLists,
    selectedSuppressionLists,
    clearSelections,
    toggleListSelection,
    selectedSendListsSizes,
    selectedSuppressionListsSizes,
  } = useAudienceContext();

  const { campaign } = useCampaignContext();

  const isEligibility = getIsEligibilityCampaign(campaign.campaignTypeDefinition);

  const hasSendList = selectedSendLists?.length > 0;
  const hasSuppressionList = selectedSuppressionLists?.length > 0;
  const hasSelections = hasSuppressionList || hasSendList;

  return (
    <SummaryWrapper data-test={AUDIENCE_LIST_SUMMARY_TEST_ID}>
      <SummaryHeader data-test={AUDIENCE_LIST_SUMMARY_HEADER_TEST_ID}>
        Selected audience
        {hasSelections && (
          <TextButton
            data-test={AUDIENCE_LIST_SUMMARY_ACTION_LINK_TEST_ID}
            onClick={clearSelections}
          >
            {isEligibility ? 'Clear' : 'Clear all'}
          </TextButton>
        )}
      </SummaryHeader>
      <SummaryBody data-test={AUDIENCE_LIST_SUMMARY_BODY_TEST_ID}>
        {!hasSelections ? (
          <NoResults />
        ) : (
          <>
            {hasSendList && (
              <ListDetail
                listType={isEligibility ? ListAction.Eligible : ListAction.Send}
                list={selectedSendLists}
                onRemove={(item) =>
                  toggleListSelection(isEligibility ? ListAction.Eligible : ListAction.Send, item)
                }
                selectedListsSizes={selectedSendListsSizes}
              />
            )}
            {hasSuppressionList && (
              <ListDetail
                listType={ListAction.Suppress}
                list={selectedSuppressionLists}
                onRemove={(item) => toggleListSelection(ListAction.Suppress, item)}
                selectedListsSizes={selectedSuppressionListsSizes}
              />
            )}
          </>
        )}
      </SummaryBody>
    </SummaryWrapper>
  );
};
